export default {
    setMenuItem: function (id, property, value) {
        console.log("setMenuItem");
    }
}
